import React from 'react';
import { ProFormaIntlProvider } from '@atlassian/proforma-common-core/intl-provider';
import * as i18nMessages from '../../i18n';
export const PackageIntlProvider = ({
  children,
  locale
}) => /*#__PURE__*/React.createElement(ProFormaIntlProvider, {
  i18nMessages: i18nMessages,
  locale: locale
}, children);